import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { beforeItems, afterItems } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function ScreenTime() {
  return <section className="bg-cream px-4 py-14 sm:px-5 sm:py-24" data-id="element-188" data-mp="23qxid2x0vjql">
      <div className="mx-auto max-w-5xl" data-id="element-189" data-mp="28q0efxv0yfmf">
        <Reveal data-id="element-190" data-mp="28op75o2depqk">
          <SectionLabel data-id="element-191" data-mp="28rbf3ot6b79b">La scomoda realtà</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[26ch] text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-192" data-mp="1b2rsk1r434jw">
            Vuoi meno tempo passivo davanti agli schermi.{' '}
            <span className="text-orange" data-id="element-193" data-mp="1kzeektv6c1ni">
              Ma ti serve qualcosa che vogliano fare davvero.
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-5 sm:text-lg" data-id="element-194" data-mp="1p32lrbfw8v88">
            Vuoi che imparino divertendosi, senza passare i pomeriggi a caccia
            di idee, comprando kit costosi o preparando attività che durano
            meno del tempo che ci hai messo a organizzarle.
          </p>
        </Reveal>

        <div className="mt-9 grid gap-4 sm:mt-12 sm:gap-6 md:grid-cols-2" data-id="element-195" data-mp="2zrj15sjbtj6s">
          <Reveal data-id="element-196" data-mp="2uqva56v3l2ck">
            <div className="h-full rounded-[1.5rem] border-2 border-orange/25 bg-white p-6 sm:rounded-[1.75rem] sm:p-8" data-id="element-197" data-mp="2uqd7nshudrw7">
              <p className="text-[10px] font-black uppercase tracking-[0.18em] text-orange" data-id="element-198" data-mp="2qp9oox4hzfqr">
                Prima
              </p>
              <h3 className="mt-3 text-lg font-black leading-snug text-ink sm:text-xl" data-id="element-199" data-mp="2gzzyxnx4m95t">
                Il pomeriggio finisce davanti a un video perché non c’è
                un’alternativa pronta
              </h3>
              <ul className="mt-5 space-y-3 sm:mt-6 sm:space-y-3.5" data-id="element-200" data-mp="2723luqkmp452">
                {beforeItems.map(item => <li key={item.text} className="flex gap-3" data-id="element-201" data-mp="22zyww554kvor">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-orange/10" aria-hidden="true" data-id="element-202" data-mp="22zfigyeoopfh">
                      <XIcon className="h-3 w-3 text-orange" strokeWidth={4} data-id="element-203" data-mp="1od09qmdawnfu" />
                    </span>
                    <span className="text-[15px] font-semibold leading-relaxed text-ink/70 sm:text-base" data-id="element-204" data-mp="1sfmw47r7dg5n">
                      {item.text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.06} data-id="element-205" data-mp="1jeozwbn0acxm">
            <div className="h-full rounded-[1.5rem] border-2 border-moss bg-moss p-6 shadow-card sm:rounded-[1.75rem] sm:p-8" data-id="element-206" data-mp="274138uvnjqs0">
              <p className="text-[10px] font-black uppercase tracking-[0.18em] text-sun" data-id="element-207" data-mp="2c3dt7ohtldyt">
                Con il Laboratorio del Giovane Inventore
              </p>
              <h3 className="mt-3 text-lg font-black leading-snug text-cream sm:text-xl" data-id="element-208" data-mp="22db0lpem2210">
                Aprite il laboratorio, scegliete una missione e iniziate a
                costruire
              </h3>
              <ul className="mt-5 space-y-3 sm:mt-6 sm:space-y-3.5" data-id="element-209" data-mp="2utbyxxy5auza">
                {afterItems.map(item => <li key={item.text} className="flex gap-3" data-id="element-210" data-mp="jemu8sdwbbgu">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sun" aria-hidden="true" data-id="element-211" data-mp="jcs9be2mjjcr">
                      <CheckIcon className="h-3 w-3 text-ink" strokeWidth={4} data-id="element-212" data-mp="s6x3o7gyvcx1" />
                    </span>
                    <span className="text-[15px] font-semibold leading-relaxed text-cream/85 sm:text-base" data-id="element-213" data-mp="o5leu45x2vpw">
                      {item.text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}